import { createContext, useContext } from 'react';

import { IApplicationsStore } from '@/domain/applications/ApplicationsStore';

const ApplicationsStoreContext = createContext<IApplicationsStore>(null);
const useApplicationsStore = () => {
	const context = useContext(ApplicationsStoreContext);

	if (context === undefined) {
		throw Error('useApplicationsStore must be used within an ApplicationsProvider');
	}

	return context;
};
const ApplicationsStoreContextProvider = ApplicationsStoreContext.Provider;

export { useApplicationsStore, ApplicationsStoreContextProvider };
export default ApplicationsStoreContext;
